module.exports = __webpack_public_path__ + "static/media/warning.3f204b54.svg";